var exports = {
  "LU": "PremiumSurface.module__tokens___Y2RXWk",
  "Nr": "PremiumSurface.module__card___Y2RXWk",
  "RB": "PremiumSurface.module__cardHover___Y2RXWk",
  "Q1": "PremiumSurface.module__headingFill___Y2RXWk",
  "Fo": "PremiumSurface.module__buyAccent___Y2RXWk",
  "xC": "PremiumSurface.module__buyLight___Y2RXWk",
  "sM": "PremiumSurface.module__srOnly___Y2RXWk",
};

module.exports = exports;
